module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "kp-select-open",
    attrs: {
      "href": "javascript:;",
      "title": "Exportar"
    },
    on: {
      "click": function($event) {
        _vm.modalOpen('code');
        _vm.codeSetupBox(_vm.box)
      }
    }
  }, [_c('i', {
    staticClass: "kp-panel-import"
  }), _vm._v(_vm._s(_vm.$t('general.actions.export')) + "\n")])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-4b840535!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/list/item/ButtonExport.vue
 ** module id = 819
 ** module chunks = 1
 **/